/* __next_internal_client_entry_do_not_use__ BrandMinimum auto */ import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { MaybeBrandReviewTile } from "@faire/retailer-visitor-shared/components/MaybeBrandReviewTile/MaybeBrandReviewTile";
import { useStrictLocalization } from "@faire/web--source/common/localization/localize";
import { formatMoney } from "@faire/web--source/common/money";
import { Row } from "@faire/web--source/slate/Layout";
import { Typography } from "@faire/web--source/slate/Typography";
import React from "react";
export var BrandMinimum = function(props) {
    var strictLocalize = useStrictLocalization().strictLocalize;
    var minimumOrderAmount = props.minimumOrderAmount, avgBrandReviewRating = props.avgBrandReviewRating;
    var getMinimumText = function() {
        if (minimumOrderAmount) {
            return strictLocalize({
                id: "hvX3CB",
                defaultMessage: [
                    {
                        type: 1,
                        value: "minMoney"
                    },
                    {
                        type: 0,
                        value: " min"
                    }
                ]
            }, {
                minMoney: formatMoney({
                    money: minimumOrderAmount,
                    omitCentsIfZero: true
                })
            });
        }
        return null;
    };
    if (!props.isLoggedInRetailer) {
        return null;
    }
    return /*#__PURE__*/ _jsxs(Row, {
        children: [
            /*#__PURE__*/ _jsx(MaybeBrandReviewTile, {
                rating: avgBrandReviewRating
            }),
            /*#__PURE__*/ _jsx(Typography, {
                children: getMinimumText()
            })
        ]
    });
};
